import React, { FC, ReactNode } from 'react';
import './InputField.css';
import { ErrorMessage, Field } from '@/Shared/Lib/Logic';

interface InputFieldProps {
	label?: string,
	icon?: ReactNode,
	name: string,
	placeholder?: string,
	type?: string,
	autoComplete?: string,
	readOnly?: boolean,
	required?: boolean,
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
	value?: any,
	min?: any
	max?: any
	step?: any
}

const InputField: FC<InputFieldProps> = ({
	label,
	icon,
	name,
	placeholder,
	type = 'text',
	autoComplete,
	readOnly = false,
	required = false,
	onChange,
	value,
	min,
	max,
	step
}) => (

	<label
		className={`InputField data-field-label ${readOnly ? 'readonly' : ''} ${type === 'hidden' ? 'InputField--hidden' : ''}`}
		data-testid="InputField"
		title={readOnly ? 'Champ non modifiable' : 'Champ modifiable'}>
		{label && (<div>{label} {required && <span className="asterisk" aria-hidden="true"> *</span>}</div>) }
		
		<div className="form-group">
			<div className='Field-wrapper'>
				{icon && <div className='field-icon'>{icon}</div>}
				<Field
					readOnly={readOnly}
					id={name}
					name={name}
					type={type}
					min={min}
					max={max}
					step={step}
					className="input-field"
					placeholder={placeholder || label}
					autoComplete={autoComplete || 'off'}
					{...(onChange ? { onChange } : {})}
					{...(value ? { value } : {})}
				/>
			</div>
			<ErrorMessage name={name} component="div" className="error-message" />
		</div>
	</label>
);

export default InputField;
